import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LocalProvidersModal from '../components/Modals/LocalProvidersModal';

const { FiMapPin, FiArrowLeft, FiBell, FiAlertCircle } = FiIcons;

const Locate = () => {
  const navigate = useNavigate();
  const [isProviderModalOpen, setIsProviderModalOpen] = useState(false);

  return (
    <div className="fixed inset-0 z-[999] bg-brand-light overflow-y-auto">
      {/* Background decoration */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-accent-gold/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] bg-accent-navy/5 rounded-full blur-3xl" />
      </div>

      <div className="min-h-full flex flex-col items-center justify-center p-6 sm:p-12 pt-24 pb-24 relative z-10">
        <button 
          onClick={() => navigate(-1)}
          className="fixed top-6 left-6 flex items-center space-x-2 text-text-muted hover:text-accent-navy transition-colors z-50 p-2 bg-white/50 backdrop-blur-md border border-brand-dark rounded-full pr-4 shadow-sm"
        >
          <SafeIcon icon={FiArrowLeft} className="w-5 h-5" />
          <span className="font-medium text-sm">Go Back</span>
        </button>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="relative z-10 max-w-lg w-full bg-white rounded-3xl shadow-2xl p-8 sm:p-12 text-center border border-accent-gold/20 mt-auto mb-auto"
        >
          <div className="w-24 h-24 bg-accent-gold/10 rounded-full flex items-center justify-center mx-auto mb-8 relative">
            <SafeIcon icon={FiMapPin} className="w-12 h-12 text-accent-gold" />
            <motion.div
               animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0, 0.5] }}
               transition={{ duration: 2, repeat: Infinity }}
               className="absolute inset-0 border-2 border-accent-gold rounded-full"
            />
          </div>

          <div className="inline-flex items-center justify-center space-x-2 bg-accent-navy/10 text-accent-navy px-4 py-1.5 rounded-full mb-6">
            <SafeIcon icon={FiAlertCircle} className="w-4 h-4" />
            <span className="text-sm font-semibold uppercase tracking-wider">Coming Soon</span>
          </div>

          <h1 className="text-4xl sm:text-5xl font-serif text-accent-navy mb-4">
            Vehicle Locator
          </h1>
          
          <div className="text-text-muted text-lg mb-8 leading-relaxed space-y-4">
            <p>
              We are currently building an intelligent transportation and vehicle discovery network designed to help you quickly locate nearby rental, memorial, emergency, and transportation vehicles through a seamless real-time map experience.
            </p>
            <p>
              This feature will be available shortly. In the meantime, use our “Find Local Provider” service to locate the nearest available transportation or vehicle service provider in your area.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => setIsProviderModalOpen(true)}
              className="w-full sm:w-auto px-8 py-3 bg-accent-navy text-white rounded-full font-medium hover:bg-accent-navy/90 transition-all shadow-md hover:shadow-lg"
            >
              Locate Provider
            </button>
            
            <button 
              onClick={() => alert("You will be notified when this feature goes live!")}
              className="w-full sm:w-auto px-8 py-3 bg-white text-accent-navy border border-accent-navy rounded-full font-medium hover:bg-gray-50 transition-all flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiBell} className="w-5 h-5" />
              <span>Notify Me</span>
            </button>
          </div>
        </motion.div>
      </div>

      <LocalProvidersModal 
        isOpen={isProviderModalOpen} 
        onClose={() => setIsProviderModalOpen(false)} 
      />
    </div>
  );
};

export default Locate;